<template>
  <div class="header">
    <div class="patient-banner">
      <div class="patient-main-info">
        <h1 style="color: #fff">👂 ENT Clinic</h1>
        <div class="patient-id-section">
          <span class="patient-id">Patient Name: {{ patient.name }}</span>
          <span class="patient-id">OPD: {{ patient.opd }}</span>
          <span class="gestational-age"
            >Age: {{ getAge(patient.dob) }} years</span
          >
          <span class="last-visit"
            >Gender: {{ patient.gender == 1 ? "Male" : "Female" }}</span
          >
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <ent_head :visit_id="visit_id" />
  </div>
</template>

<script>
import getAge from "../../../timezone/dob_to_age";
import ent_head from "./ent_head.vue";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "ancheading",
  data() {
    return {
      showEditModal: false,
      patient: {},
    };
  },
  components: {
    ent_head,
  },
  props: {
    visit_id: {
      type: [String, Number],
      required: false,
    },
  },
  methods: {
    getAge,
    activeTabChange() {
      this.loading = true;
    },
    async get_patient_details() {
      const url = "get_patient_object_from_visit/" + this.visit_id;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      this.patient = res.data;
    },
  },
  mounted() {
    this.get_patient_details();
  },
};
</script>

<style scoped>
.header {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  overflow: hidden;
}
.patient-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, #54316c 0%, #5708a5 100%);
  color: white;
}

.patient-main-info h1 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.patient-main-info h1 i {
  margin-right: 10px;
}
.patient-id-section {
  display: flex;
  gap: 30px;
  font-size: 16px;
}

.patient-id-section span {
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: 600;
}
@media (max-width: 576px) {
  .patient-banner {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .patient-id-section {
    flex-direction: column;
    gap: 10px;
  }

  .gp-score {
    grid-template-columns: 1fr;
  }

  .stats-bar {
    grid-template-columns: 1fr;
  }
}
</style>
